// Module I/O interchange
import Toggle from '../../modules/Toggle'
import ReferralCode from '../../modules/ReferralCode';

import InputFormat from './InputFormat';
import CustomRangeSlider from './CustomRangeSlider';
import CustomDropdown from './CustomDropdown';
import Tooltip from './Tooltip';
import AddressLookup from './AddressLookup';

export default {
  Toggle,
  InputFormat,
  CustomRangeSlider,
  CustomDropdown,
  Tooltip,
  AddressLookup,
  ReferralCode
}



// WEBPACK FOOTER //
// ./js/self-serve/modules/index.js